import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
  const Comp = motion[as];
  return (
    <Comp
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, ease: EASE, delay }}
    >
      {children}
    </Comp>
  );
};

export const MaskedWords = ({ text, className = "", delay = 0, stagger = 0.045, testId }) => {
  const words = text.split(" ");
  return (
    <span className={className} data-testid={testId} aria-label={text}>
      {words.map((w, i) => (
        <span key={i} aria-hidden="true" className="inline-block overflow-hidden align-bottom pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className="inline-block"
            initial={{ y: "105%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.1, ease: EASE, delay: delay + i * stagger }}
          >
            {w}
            {i < words.length - 1 ? "\u00A0" : ""}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

export const ClipImage = ({ src, alt, className = "", imgClassName = "grayscale contrast-[1.02] brightness-[1.03]", testId }) => (
  <motion.div
    className={`relative overflow-hidden ${className}`}
    initial={{ opacity: 0.001 }}
    whileInView={{ opacity: 1 }}
    viewport={{ once: true, amount: 0.1 }}
    data-testid={testId}
  >
    <motion.img
      src={src}
      alt={alt}
      loading="lazy"
      className={`h-full w-full object-cover ${imgClassName}`}
      initial={{ scale: 1.18 }}
      whileInView={{ scale: 1 }}
      viewport={{ once: true, amount: 0.1 }}
      transition={{ duration: 1.6, ease: EASE }}
    />
  </motion.div>
);

export const PageHeader = ({ eyebrow, title, intro, testId }) => (
  <section className="relative hero-band grain pt-36 sm:pt-44 lg:pt-52 pb-20 lg:pb-28" data-testid={testId}>
    <div className="container-x">
      <Reveal>
        <p className="eyebrow mb-8 flex items-center gap-4 text-[var(--ink-soft)]"><span className="inline-block h-px w-8 bg-current" />{eyebrow}</p>
      </Reveal>
      <h1 className="font-serif-display display-xl text-[2.5rem] sm:text-5xl lg:text-[4rem] leading-[1.06] max-w-[52rem]">
        <MaskedWords text={title} delay={0.15} />
      </h1>
      {intro && (
        <Reveal delay={0.5}>
          <p className="mt-8 lg:mt-10 max-w-[36rem] lead text-[var(--ink-soft)]">{intro}</p>
        </Reveal>
      )}
    </div>
  </section>
);
